/**
 * Trunnion AI - Loading Spinner Component
 */

import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6',
  lg: 'h-10 w-10',
};

export function LoadingSpinner({
  size = 'md',
  label,
  className = '',
}: LoadingSpinnerProps) {
  return (
    <div className={`flex flex-col items-center gap-3 ${className}`}>
      <Loader2
        className={`animate-spin text-trunnion-gold-500 ${sizeClasses[size]}`}
      />
      {label && (
        <p className="text-sm text-trunnion-slate-400">{label}</p>
      )}
    </div>
  );
}
